import { t } from 'i18next';

import { CourseFormatEnum } from '@/models/Course';
import { SecondarySelectOption } from '@/components/ui/custom/secondary/SecondarySelect';

const translate = (courseFormat: CourseFormatEnum): string | '' => {
  const translations = {
    [CourseFormatEnum.IN_PERSON]: t('courseFormats.IN_PERSON'),
    [CourseFormatEnum.ONLINE]: t('courseFormats.ONLINE'),
    [CourseFormatEnum.SCHOOL]: t('courseFormats.SCHOOL'),
    [CourseFormatEnum.EXTRA_COURSE]: t('courseFormats.EXTRA_COURSE'),
    [CourseFormatEnum.SELF_PACED]: t('courseFormats.SELF_PACED'),
  };

  return translations[courseFormat];
};

export const courseFormatsOptions = (): SecondarySelectOption[] =>
  Object.values(CourseFormatEnum).map(format => ({
    label: translate(format),
    value: format,
  }));
